var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:_vm.theme},[(_vm.$slots['header'])?_c('div',{staticClass:"cardHeader"},[_vm._t("header")],2):_vm._e(),_vm._t("default"),(_vm.$slots['footer'])?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }